import React, { useCallback, useMemo } from 'react';
import AvailableOffersView from '@fingo/lib/features/factoring/views/AvailableOffersView';
import { OVERLAYS_MIN_HEIGHT } from '@fingo/lib/theme/constants/data-grid';
import AvailableOffersOverlay from '../../../../features/factoring/components/overlays/AvaliableOffersOverlay';
import { getColumns } from '../../../../features/factoring/constants/available-offers';
import OPTIONS from '../../../../features/factoring/constants/available-offers-options';
import useAvailableOffersState from '../../../../features/factoring/hooks/useAvailableOffersState';
import useAvailableOffersSteps from '../../../../features/factoring/hooks/useAvailableOffersSteps';

const AvailableOffers = () => {
  const state = useAvailableOffersState();

  const {
    isMobile,
    offerIds,
    currency,
    showConfirmationSummary,
    setShowConfirmationSummary,
    showCessionStep,
    setShowCessionStep,
    lockedConstraint,
    getRowClassName,
    isRowSelectable,
    handleSelectionModelChange,
    onCompletedSetRows,
    isBlocked,
    unavailabilityCode,
    blockOperationDialogProps,
    handleActionClick,
    handleShowConfirmationSummary,
    handleRegisterCessionNavigation,
    cessionStepperNavigation,
    stepsCallbacks,
  } = state;

  const disabledRowTooltip = useCallback(
    (row) => OPTIONS.getDisabledRowTooltip(row, lockedConstraint),
    [lockedConstraint],
  );

  const stepsConditions = useMemo(
    () => OPTIONS.getStepsConditions({
      offerIds,
      showConfirmationSummary,
      showCessionStep,
      cessionStepperNavigation,
    }),
    [offerIds, showConfirmationSummary, showCessionStep, cessionStepperNavigation],
  );

  const stepConfiguration = useAvailableOffersSteps(
    handleShowConfirmationSummary,
    setShowCessionStep,
    stepsConditions,
    isBlocked,
    unavailabilityCode,
    handleRegisterCessionNavigation,
  );

  const customHeaderProps = useMemo(() => ({
    ...OPTIONS.getStepHeader({ showCessionStep, showConfirmationSummary }),
    selectedDteType: lockedConstraint,
    useBorderedTitle: true,
    onActionClick: handleActionClick,
    customFiltersProps: { shouldLoadNewInvoices: false },
  }), [
    lockedConstraint,
    stepsConditions,
    stepsCallbacks,
    handleActionClick,
    showCessionStep,
    showConfirmationSummary,
  ]);

  return (
    <AvailableOffersView
      enableBlockOperationFlow
      getColumns={getColumns}
      includeHeaders={OPTIONS.headers}
      mobileHeaders={OPTIONS.mobileHeaders}
      OverlayComponent={AvailableOffersOverlay}
      disabledRowTooltip={disabledRowTooltip}
      customHeaderProps={customHeaderProps}
      stepConfiguration={stepConfiguration}
      gridMinHeight={OVERLAYS_MIN_HEIGHT}
      isMobile={isMobile}
      currency={currency}
      offerIds={offerIds}
      showConfirmationSummary={showConfirmationSummary}
      setShowConfirmationSummary={setShowConfirmationSummary}
      getRowClassName={getRowClassName}
      isRowSelectable={isRowSelectable}
      handleSelectionModelChange={handleSelectionModelChange}
      onCompletedSetRows={onCompletedSetRows}
      isBlocked={isBlocked}
      unavailabilityCode={unavailabilityCode}
      blockOperationDialogProps={blockOperationDialogProps}
    />
  );
};

export default AvailableOffers;
